import React, { useState, useEffect } from "react";
import { ShoppingCart, Star,X ,CreditCard } from 'lucide-react';
import { useNavigate, useLocation } from "react-router-dom";
import { useCurrency } from '../Currencycontext';
import './productdetails.css';

export default function ProductDetails() {
  const { currency, convertPrice } = useCurrency();
  const navigate = useNavigate();
  const location = useLocation();
  const productFromState = location.state?.product;

  const [product, setProduct] = useState(null);
  const [userCartIds, setUserCartIds] = useState([]);
  const [config, setConfig] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [activeTab, setActiveTab] = useState('specifications');
  const [reviews, setReviews] = useState([]);
  const [newReview, setNewReview] = useState({ name: '', email: '', rating: 0, comment: '' });
  const [pendingCartItem, setPendingCartItem] = useState(null);
  const [user, setUser] = useState(null);
    const [message, setMessage] = useState(null);
  const [question, setQuestion] = useState("");
  const [qna, setQna] = useState([]);
  // For reviews
const [visibleReviews, setVisibleReviews] = useState(3);

// For QnA
const [visibleQna, setVisibleQna] = useState(3);



  // Load config.json
  useEffect(() => {
    fetch("/config.json")
      .then(res => res.json())
      .then(data => setConfig(data))
      .catch(err => console.error("Failed to load config.json", err));
  }, []);

  // Fetch logged-in user info
 useEffect(() => {
  if (!config) return;

  fetch(`${config.BASE_URL}${config.USER_INFO}`, {
    method: "POST",       
    credentials: "include"
  })
  .then(res => res.json())
  .then(data => {
    if (data.success && data.is_active) {
      setUser({
        id: data.user_id,
        name: data.fullname,
        address1: data.address1,
        address2: data.address2
      });
    } else {
      setUser(null);
    }
  })
  .catch(err => {
    console.error("Failed to fetch user session:", err);
    setUser(null);
  });
}, [config]);

  useEffect(() => {
    if (!productFromState) return;

      const getSafeFileUrl = (file, folder) => {
    if (!file) return null;
    const fileName = file.split("\\").pop(); 
    return `/${folder}/${productFromState.product_id}/${encodeURIComponent(fileName)}`;
  };

    const productImages = [
      productFromState.image_path,
      productFromState.image1,
      productFromState.image2,
      productFromState.image3,
      productFromState.image4
    ].filter(Boolean).map(img => getSafeFileUrl(img, "product_thumbnails"));

    const documentsArray = productFromState.documents
      ? typeof productFromState.documents === "string"
        ? productFromState.documents.split(",").map(doc => getSafeFileUrl(doc, "product_documents"))
       : Array.isArray(productFromState.documents)
      ? productFromState.documents.map(doc => getSafeFileUrl(doc, "product_documents"))
      : []
      : [];
     const videoFileUrl = getSafeFileUrl(productFromState.videofile, "product_thumbnails");
    setProduct({
      ...productFromState,
      images: productImages,
      documents: documentsArray,
      videofile: videoFileUrl,
      overview: [productFromState.category_name, productFromState.domain_name]
    });
  }, [productFromState]);

  // Fetch product reviews
  useEffect(() => {
    if (!config || !product) return;
    fetch(`${config.BASE_URL}${config.GET_REVIEWS}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ product_id: product.product_id })
    })
      .then(res => res.json())
      .then(data => {
        if (data.success && data.reviews) {
          setReviews(data.reviews.map(r => ({
            id: r.id,
            name: r.user_name || r.name,
            email: r.email || "",
            rating: parseInt(r.rating),
            comment: r.review,
            date: r.added_at?.split('T')[0] || new Date().toISOString().split('T')[0]
          })));
        }
      })
      .catch(err => console.error("Failed to fetch reviews:", err));
  }, [config, product]);

  // Fetch user cart
  useEffect(() => {
    if (!config) return;
    fetch(`${config.BASE_URL}${config.GET_CART}`, { method: "POST", credentials: "include" })
      .then(res => res.json())
      .then(data => {
        if (data.success && data.cart) setUserCartIds(data.cart.map(item => item.product_id));
      })
      .catch(err => console.error("Failed to fetch user cart:", err));
  }, [config]);


      useEffect(() => {
    if (message) {
      const timer = setTimeout(() => setMessage(null), 3000);
      return () => clearTimeout(timer);
    }
  }, [message]);

 const handleBuyNow = () => {
  // Navigate to checkout page and pass product details
  navigate("/checkout", {
    state: { buyNowProduct: { 
      product_id: product.product_id,
      title: product.title,
      price: parseFloat(product.price),
      tax: parseFloat(product.tax || 0),
      quantity: 1
    } }
  });
};

 useEffect(() => {
    if (!pendingCartItem || !config) return;
    const formData = new FormData();
    Object.entries(pendingCartItem).forEach(([key, value]) => formData.append(key, value));
    fetch(`${config.BASE_URL}${config.ADD_TO_CART}`, { method: "POST", body: formData, credentials: "include" })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setUserCartIds(prev => [...prev, pendingCartItem.product_id]);
          let currentCount = Number(window.cartCount || localStorage.getItem("cartCount") || 0);
          currentCount += 1;
          window.cartCount = currentCount;
          localStorage.setItem("cartCount", currentCount);
          window.dispatchEvent(new Event("cartUpdated"));
          setMessage("Added to cart successfully!");
        } else {
          setMessage(data.message || "Failed to add to cart");
        }
      })
      .catch(err => console.error("Add to cart failed:", err))
      .finally(() => setPendingCartItem(null));
  }, [pendingCartItem, config]);

  const handleRatingChange = (rating) => setNewReview({ ...newReview, rating });

  const handleReviewSubmit = async (e) => {
    e.preventDefault();
    if (!config) return;
    try {
      const response = await fetch(`${config.BASE_URL}${config.SUBMIT_REVIEW}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ product_id: product.product_id, review: newReview.comment, rating: newReview.rating, user_name: newReview.name })
      });
      const data = await response.json();
      if (data.success) {
        const review = { id: data.review_id || reviews.length + 1, name: newReview.name, email: newReview.email, rating: newReview.rating, comment: newReview.comment, date: new Date().toISOString().split('T')[0] };
        setReviews([...reviews, review]);
        setNewReview({ name: '', email: '', rating: 0, comment: '' });
        setMessage("Review submitted successfully!");
      } else alert(data.message || "Failed to submit review");
    } catch (err) {
      console.error("Review submission failed:", err);
      setMessage("Failed to submit review. Please try again.");
    }
  };

  useEffect(() => {
  if (!config || !product) return;

  fetch(`${config.BASE_URL}${config.GET_QNA}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ product_id: product.product_id })
  })
    .then(res => res.json())
    .then(data => {
      if (data.success && data.qna) {
        setQna(data.qna);
      }
    })
    .catch(err => console.error("Failed to fetch Q&A:", err));
}, [config, product]);


  const handleQuestionSubmit = async (e) => {
    e.preventDefault();
    if (!config || !question.trim()) return;
    try {
      const response = await fetch(`${config.BASE_URL}${config.SUBMIT_QUESTION}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ product_id: product.product_id, question_text: question })
      });
      const data = await response.json();
      if (data.success) {
        setMessage("Your question has been submitted!");
        setQuestion("");
      } else alert(data.message || "Failed to submit question");
    } catch (err) {
      console.error("Question submission failed:", err);
      setMessage("Failed to submit question. Please try again.");
    }
  };

  if (!product) return <div>Loading...</div>;

  const thumbnails = [...(product.images || []), ...(product.videofile ? [product.videofile] : [])];
  const prevImage = () => setCurrentImageIndex(prev => prev === 0 ? thumbnails.length - 1 : prev - 1);
  const nextImage = () => setCurrentImageIndex(prev => prev === thumbnails.length - 1 ? 0 : prev + 1);

  const tabContent = {
    description: { title: "Description", content: <p style={{ marginBottom: "10px" }}>{product.description2}</p> },
    specifications: { title: "Technical Specifications", content: <p>{product.specifications}</p> },
    documentation: {
      title: "Data Sheets",
      content: (
        <ul className="features-list">
          {(product.documents || []).map((doc, i) => {
            const fileName = doc.split("/").pop();
            const displayName = fileName.includes("_") ? fileName.split("_").slice(1).join("_") : fileName;
            return <li key={i}><a href={doc} download target="_blank" rel="noreferrer">{displayName}</a></li>;
          })}
        </ul>
      )
    },
  reviews: {
  title: "Customer Reviews",
  content: (
    <div className="reviews-tab">
      <div className="reviews-content">
        <div className="reviews-list">
          {reviews.length === 0 ? (
            <p>No reviews yet.</p>
          ) : (
            <>
              {reviews.slice(0, visibleReviews).map(review => (
                <div key={review.id} className="review-item">
                  <div className="review-header">
                    <div className="reviewer-info">
                      <h4>{review.name}</h4>
                      <span>{review.email}</span>
                    </div>
                    <div className="review-rating">
                      {[...Array(5)].map((_, i) => (
                        <span
                          key={i}
                          className={`star ${i < review.rating ? 'filled' : ''}`}
                        >
                          ★
                        </span>
                      ))}
                    </div>
                  </div>
                  <p className="review-comment">{review.comment}</p>
                  <span className="review-date">{review.date}</span>
                </div>
              ))}

              {visibleReviews < reviews.length && (
                <button
                  className="show-more-button"
                  onClick={() => setVisibleReviews(prev => prev + 3)}
                >
                  Show More
                </button>
              )}
            </>
          )}
        </div>

        <div className="review-form-container">
          <h4>Submit Your Review</h4>
          <form onSubmit={handleReviewSubmit} className="review-form">
            <div className="form-group">
              <input
                type="text"
                placeholder="Your Name"
                value={newReview.name}
                onChange={e => setNewReview({ ...newReview, name: e.target.value })}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="email"
                placeholder="Your Email"
                value={newReview.email}
                onChange={e => setNewReview({ ...newReview, email: e.target.value })}
                required
              />
            </div>
            <div className="form-group">
              <textarea
                placeholder="Your Review"
                value={newReview.comment}
                onChange={e => setNewReview({ ...newReview, comment: e.target.value })}
                required
              />
            </div>
            <div className="rating-input">
              <span>Rating:</span>
              {[1,2,3,4,5].map(star => (
                <span
                  key={star}
                  className={`star ${star <= newReview.rating ? 'filled' : ''}`}
                  onClick={() => handleRatingChange(star)}
                >
                  ★
                </span>
              ))}
            </div>
            <button type="submit" className="submit-review-button">
              Submit Review
            </button>
          </form>
        </div>
      </div>
    </div>
  )
},

        qanda: {
          title: "Questions & Answers",
          content: (
            <div className="qanda-tab">
              <div className="qanda-container">
                {/* Left: Questions & Answers */}
                <div className="qna-list">
          {qna.length === 0 ? (
            <p>No questions yet.</p>
          ) : (
            <>
              {qna.slice(0, visibleQna).map(item => (
                <div key={item.qa_id} className="qna-item">
                  <p><strong>Q:</strong> {item.question}</p>
                  <p><strong>A:</strong> {item.answer || "Awaiting answer"}</p>
                </div>
              ))}

              {visibleQna < qna.length && (
                <button
                  className="show-more-button"
                  onClick={() => setVisibleQna(prev => prev + 3)}
                >
                  Show More
                </button>
              )}
            </>
          )}

        </div>


        {/* Right: Ask a Question Form */}
        <div className="qna-form">
          {user ? (
            <form onSubmit={handleQuestionSubmit}>
              <textarea
                placeholder="Ask your question here..."
                value={question}
                onChange={(e) => setQuestion(e.target.value)}
                required
              />
              <button type="submit">Submit Question</button>
            </form>
          ) : (
            <p style={{ color: 'red' }}>
              Only logged-in users are allowed to ask questions.
            </p>
          )}
        </div>
      </div>
    </div>
  )
},
    warranty: { title: "Warranty", content: <p>{product.warranty}</p> }
  };

  return (
    <div className="product-page">
      {message && (
        <div
          style={{
            position: "fixed",
            top: "80px",
            left: "50%",
            transform: "translateX(-50%)",
            padding: "15px 20px",
            borderRadius: "12px",
            background: "rgba(255,255,255,0.15)",
            backdropFilter: "blur(10px)",
            WebkitBackdropFilter: "blur(10px)",
            boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
            color: "black",
            fontSize: "14px",
            fontWeight: "500",
            zIndex: 1000,
            minWidth: "250px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          <span>{message}</span>
          <X
            size={18}
            style={{ marginLeft: "15px", cursor: "pointer" }}
            onClick={() => setMessage(null)}
          />
        </div>
      )}
      <div className="product-details-container">
        <div className="thumbnail-column">
          <div className="thumbnail-container">
            {thumbnails.map((item, index) => (
              <div key={index} className={`thumbnail ${currentImageIndex === index ? 'active' : ''}`} onClick={() => setCurrentImageIndex(index)}>
                {item === product.videofile ? <video src={item} /> : <img src={item} alt={`Thumbnail ${index+1}`} />}
              </div>
            ))}
          </div>
        </div>

        <div className="image-column">
          <div className="product-image-box">
            <button onClick={prevImage} className="arrow-button left">&#8592;</button>
            <div className="product-image-container">
              {thumbnails[currentImageIndex] === product.videofile ? (
                <video controls className="product-image"><source src={product.videofile} type="video/mp4"/></video>
              ) : (
                <img src={thumbnails[currentImageIndex]} alt={`Product Image ${currentImageIndex+1}`} className="product-image"/>
              )}
            </div>
            <button onClick={nextImage} className="arrow-button right">&#8594;</button>
          </div>
        </div>

        <div className="product-info-column">
          <div className="product-info">
            <h2 className="product-title">{product.title}</h2>
            <div className="price-rating">
             <span className="product-price">
  {currency === "INR" ? "₹" : "$"} {convertPrice(parseFloat(product.price) + parseFloat(product.tax || 0))} (inclusive of tax)
</span>

            </div>
            <button
              className="add-to-cart-button"
              onClick={() => setPendingCartItem({ product_id: product.product_id, product_title: product.title, quantity: 1 })}
              disabled={userCartIds.includes(product.product_id)}
            >
              <ShoppingCart size={18} className="mr-1"/>
              {userCartIds.includes(product.product_id) ? "In Cart" : "Add to Cart"}
            </button>
            <button
              className="add-to-cart-button"  
              onClick={handleBuyNow}
            >
             <CreditCard size={18} className="mr-1" />
              Buy Now
            </button>
            <div className="product-overview">
              <p style={{marginBottom:20}}>{product.description}</p>
              <ul className="features-list">{product.overview?.map((f,i) => <li key={i}>{f}</li>)}</ul>
            </div>
          </div>
        </div>
      </div>

      <div className="tab-section-container">
        <h2 className="tab-section-title">Need more information about this product?</h2>
        <div className="tab-content-wrapper">
          <div className="tab-buttons">
            {Object.keys(tabContent).map(tab => (
              <button key={tab} className={`tab-button ${activeTab===tab ? 'active' : ''}`} onClick={() => setActiveTab(tab)}>
                {tabContent[tab].title}
              </button>
            ))}
          </div>
          <div className="tab-panel">
            <h3 className="tab-panel-title">{tabContent[activeTab].title}</h3>
            <div className="tab-panel-content">{tabContent[activeTab].content}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
